export const periodType = {
  Daily: ["Daily"],
  Weekly: ["Weekly"],
  Monthly: ["Monthly"],
  Yearly:["Yearly"],
};
